module.exports = __webpack_public_path__ + "assets/images/QR-studio-mobile.jpg";